import { Icon } from "@2solve/tosolve-icons";
import * as IconsImgs from "@2solve/tosolve-icons/dist/icons";
import PropTypes from "prop-types";

export const IconToSolve = ({
  iconName,
  color = "#004196",
  height,
  width,
  className,
}) => {
  const IconImg = IconsImgs[iconName];
  return (
    <span
      className={className}
      style={{
        display: "inline-block",
        width: width,
        height: height,
        lineHeight: 0,
      }}
    >
      <Icon color={color} height={height} width={width} icon={IconImg} />
    </span>
  );
};

IconToSolve.propTypes = {
  iconName: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string,
};

export default IconToSolve;
